import React from 'react';
import { FiPlus, FiChevronRight, FiTrash2 } from 'react-icons/fi';

const S = {
    wrap:    { padding: '40px', maxWidth: 800, margin: '0 auto' },
    header:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 },
    title:   { fontSize: 24, fontWeight: 700, color: '#3f3f55', margin: 0 },
    newBtn:  { display: 'flex', alignItems: 'center', gap: 8, background: '#29b8e5', color: '#fff',
               border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
    empty:   { textAlign: 'center', padding: '80px 0', color: '#6b6b8a' },
    emptyH:  { fontSize: 18, fontWeight: 600, color: '#3f3f55', marginBottom: 8 },
    card:    { background: '#fff', borderRadius: 10, border: '1px solid #e0e0ec', padding: '18px 20px',
               marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer',
               transition: 'box-shadow 0.15s' },
    cardName:{ fontSize: 15, fontWeight: 600, color: '#3f3f55' },
    cardMeta:{ fontSize: 12, color: '#6b6b8a', marginTop: 3 },
    cardRight:{ display: 'flex', alignItems: 'center', gap: 12 },
    delBtn:  { background: 'none', border: 'none', color: '#b0b0c8', cursor: 'pointer', padding: 4,
               display: 'flex', alignItems: 'center' },
    chevron: { color: '#29b8e5' },
};

export default function RecitalList({ recitals, loading, onOpen, onDelete, onNew }) {
    if (loading) return <div style={S.wrap}><p style={{ color: '#6b6b8a' }}>Loading...</p></div>;

    return (
        <div style={S.wrap}>
            <div style={S.header}>
                <h1 style={S.title}>Recitals <span style={{ fontSize: 11, background: '#29b8e5', color: '#fff', borderRadius: 4, padding: '2px 7px', verticalAlign: 'middle', marginLeft: 8 }}>PRO</span></h1>
                <button style={S.newBtn} onClick={onNew}>
                    <FiPlus size={16}/> New Recital
                </button>
            </div>

            {recitals.length === 0 ? (
                <div style={S.empty}>
                    <div style={S.emptyH}>No recitals yet</div>
                    <p style={{ fontSize: 14 }}>Create your first recital to get started.</p>
                    <button style={{ ...S.newBtn, margin: '16px auto', display: 'inline-flex' }} onClick={onNew}>
                        <FiPlus size={16}/> New Recital
                    </button>
                </div>
            ) : (
                recitals.map(r => (
                    <div
                        key={r.id}
                        style={S.card}
                        onClick={() => onOpen(r.id)}
                        onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 12px rgba(41,184,229,0.12)'}
                        onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                    >
                        <div>
                            <div style={S.cardName}>{r.name}</div>
                            <div style={S.cardMeta}>Created {new Date(r.createdAt).toLocaleDateString()}</div>
                        </div>
                        <div style={S.cardRight}>
                            <button style={S.delBtn} onClick={e => { e.stopPropagation(); onDelete(r.id); }}>
                                <FiTrash2 size={15}/>
                            </button>
                            <FiChevronRight size={18} style={S.chevron}/>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
